<script lang="ts">
  import { previewActiveModal } from "$lib/services/store";
  import { Button } from "flowbite-svelte";
  import { onDestroy, tick } from "svelte";
  import { fade, fly } from "svelte/transition";

  export let toggleModal = false;
  export let removeHeader = false;
  export let addClass: string = "";
  export let fullWidth: boolean = false;
  let dialogElement: HTMLDialogElement;
  let offsetTop = 0;
  const isBrowser = typeof window !== 'undefined';

  const disableBodyScroll = () => {
    if (isBrowser) {
      document.body.classList.add("no-scroll");
    }
  };

  const enableBodyScroll = () => {
    if (isBrowser) {
      document.body.classList.remove("no-scroll");
    }
  };

  $: if (toggleModal) {
    tick().then(() => {
      if (dialogElement && !dialogElement.open) {
        dialogElement.showModal();
        disableBodyScroll();
      }
    });
  } else {
    if (dialogElement && dialogElement.open) {
      dialogElement.close();
      enableBodyScroll();
    }
  }

  const handleClick = (event) => {
    if (event.target.classList.contains('modal-box')) {
      closeModal();
    }
  }

  const closeModal = () => {
    toggleModal = false;
    $previewActiveModal = false;
    enableBodyScroll();
  };

  onDestroy(() => {
    enableBodyScroll();
  });
</script>

{#if toggleModal}
  <dialog
    bind:this={dialogElement}
    class={"modal-dialog" + (fullWidth ? " full-width" : "") + (addClass ? " " + addClass : "")}
    on:click={handleClick}
    on:cancel|preventDefault={closeModal}
  >
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <!-- svelte-ignore a11y-no-static-element-interactions -->
    <div
      class="overlay"
      in:fade={{ duration: 250, delay: 50 }}
      out:fade={{ duration: 250 }}
      on:click={closeModal}
    ></div>

    <div
      class={"modal-box" + (addClass ? " " + addClass : "")}
      in:fly={{ y: -5, duration: 250, delay: 50 }}
      out:fly={{ y: 5, duration: 250 }}
      style={offsetTop ? `top: calc(${offsetTop}px + 3rem);` : ""}
    >
      {#if !removeHeader}
        <header class="flex-sb-c">
          <h4><slot name="header">Modal header</slot></h4>
          <Button
            class="secondary small"
            on:click={closeModal}>Close</Button
          >
        </header>
      {/if}

      <div class="content">
        <slot />
      </div>
    </div>
  </dialog>
{/if}

<style>
  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
  }

  /* This is a fix for modal overlay in Casinofeber */
  :global(.t-cf .modal-dialog .overlay) {
      background: transparent;
  }

  dialog[open] {
    animation: fadeIn 0.3s;
    overflow-y: scroll;
  }

  dialog {
    padding: 0;
    border: none;
    background: transparent;
    max-width: 100%;
    max-height: 100%;
  }

  dialog::backdrop {
    background: rgba(0, 0, 0, 0.5);
  }

  .modal-box {
    background: white;
    padding: 1.5rem;
    border-radius: 0.5rem;
    position: relative;
    z-index: 10;
    max-width: 90%;
    margin: 0 auto;
  }

  .full-width .modal-box {
    max-width: 95%;
    width: 95%;
  }

  .search {
    margin-top: 3rem;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.95);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>
